module.exports = __webpack_public_path__ + "static/media/tiktok.cc212797.png";